<template>
  <div class="flex flex-wrap mb-2">
    <div class="w-full lg:w-3/4 flex-1 min-w-0 bg-white rounded-xl space-y-6 p-3 lg:p-6" style="position:relative">
      <!-- <loading :active="!this.showMarketingDate"
              :can-cancel="true"
              :on-cancel="onCancel"
              :is-full-page="false"
              :color="'#fff'"
              :background-color="'#000'"
              :opacity="'0.8'"
              :loader=" dots">
      </loading> -->
      <!-- <span class="text-red-500">*</span> -->
      <span class="text-grap-700 align-middle">機密受眾</span>
      <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" style="margin-top: 0px;" v-tooltip="'總共只能設定5個'"></i>
      <!-- <button
        v-if="!editPageType"
        id="marketingDate"
        class="hover:bg-gray-200 focus:outline-none rounded-xl px-2 py-0.5 ml-2 mx-auto text-gray-400 transition duration-500 ease-in-out border-2 text-xs"
        @click="teachVideo()"
      > -->
      <button
        v-if="false"
        id="marketingDate"
        class="hover:bg-gray-200 focus:outline-none rounded-xl px-2 py-0.5 ml-2 mx-auto text-gray-400 transition duration-500 ease-in-out border-2 text-xs"
        @click="teachVideo()"
      >
        {{lang['components']['Event']['MarketingDate']['video_teaching']}}
      </button>
      <div v-if="items.length < 5" class="flex">
        <!-- <div class="w-1/3 rounded-md flex items-center">
          <input
            v-if="items.length < 5"
            class="w-full rounded-md border p-1"
            type="text"
            v-model="audienceName"
            oninput = "value=value.replace(/[^\d]/g,'')"
            placeholder="請填寫受眾名稱"
          />
        </div> -->
        <div class="px-4 py-1 cursor-pointer rounded-md ml-2 hover:border-gray-200 border-transparent border-2" @click="addItem">
          <i class="pi pi-plus" style="fontSize: 0.8rem"></i>
        </div>
      </div>
      <div class="flex-1 space-y-4">
        <Accordion v-model:activeIndex="activeIndex">
          <AccordionTab v-for="(item, index) in items" :key="item.title">
            <template #header>
              <span v-if="item.editStatus == false">{{item.title}}</span>
              <!-- <div class="p-1 bg-gray-300 rounded-md cursor-pointer ml-2" title="刪除" @click="doDelete(index)">
                <img src="../../assets/clear.svg" />
              </div> -->
              <input
                v-if="item.editStatus == true"
                :ref="`myinput${index}`"
                class="w-1/3 rounded-md border p-1"
                type="text"
                v-model="item.title"
                @input="submitData(index)"
                placeholder="請填寫受眾名稱"
              />
              <i v-if="item.editStatus == false" class="pi pi-pencil align-middle text-gray-500 ml-2" title="編輯" @click="edit(index)"></i>
              <i v-if="item.editStatus == true" class="pi pi-check align-middle text-gray-500 ml-2" title="完成修改" @click="update(index)"></i>
            </template>
            <div>
              <button class="hover:bg-green-200 focus:outline-none rounded-md px-4 py-1 text-white transition duration-500 ease-in-out border-green-400 border-2 bg-green-400" @click="doAdd(index)">
                新增來源資料
              </button>
              <button class="hover:bg-red-200 focus:outline-none rounded-md px-4 py-1 text-white transition duration-500 ease-in-out border-red-400 border-2 bg-red-400 ml-2" @click="doDelete(index)">
                刪除受眾包
              </button>
              <div v-if="selectedCustomers.length > 0" class="hover:bg-red-200 focus:outline-none px-4 py-2 transition duration-500 ease-in-out cursor-pointer rounded-md ml-2 float-right border-transparent border-red-400 border-2 bg-red-400" style="height: 36px;" title="刪除來源資料" @click="deleteItem(index)">
                <img src="../../assets/clear.svg" width="13" />
              </div>
              <div v-if="selectedCustomers.length > 0" class="focus:outline-none px-4 py-1 transition duration-500 ease-in-out cursor-pointer rounded-md ml-2 float-right border-transparent border-gray-200 border-2 text-gray-400" title="重整來源資料" @click="refreshItem(index)">
                <i class="pi pi-refresh" style="fontSize: 13px;"></i>
              </div>
            </div>
            <DataTable :value="item.dataTableList" :paginator="true" class="p-datatable-customers mt-2" :rows="10"
                  dataKey="id" :rowHover="true" v-model:selection="selectedCustomers" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown" :rowsPerPageOptions="[10,25,50]"
                  currentPageReportTemplate="每頁顯示" responsiveLayout="scroll">
              <Column selectionMode="multiple"></Column>
              <Column field="name" header="來源名稱" :sortable="true" headerStyle="width: 45%">
                <template #body="slotProps">
                  <div class="text-sm" v-html="slotProps.data.name"></div>
                </template>
              </Column>
              <Column field="user" header="受眾數" :sortable="true" headerStyle="width: 30%">
                <template #body="slotProps">
                  <div class="text-sm" v-html="slotProps.data.user"></div>
                </template>
              </Column>
              <!-- <Column field="message" header="主要內容" :sortable="true"></Column> -->
              <Column field="dateTime" header="日期" :sortable="true" headerStyle="width: 25%">
                <template #body="slotProps">
                  <div class="text-sm" v-html="slotProps.data.dateTime"></div>
                </template>
              </Column>
              <!-- <Column field="touch" header="觸及人數" :sortable="true"></Column>
              <Column field="interactive" header="互動指數" :sortable="true">
                <template #body="slotProps">
                  <div class="flex"><div class="star" v-for="n in slotProps.data.interactive" :key="n">★</div></div>
                </template>
              </Column>
              <Column field="link" header="連結指數" :sortable="true">
                <template #body="slotProps">
                  <div class="flex"><div class="star" v-for="n in slotProps.data.link" :key="n">★</div></div>
                </template>
              </Column> -->
            </DataTable>
          </AccordionTab>
        </Accordion>
        <!-- <Accordion>
          <AccordionTab>
            <template #header>
              <span>Header I</span>
              <div class="p-1 bg-gray-300 rounded-md cursor-pointer ml-2" title="刪除" @click="doDelete(1)">
                <img src="../../assets/clear.svg" />
              </div>
            </template>
            Content 1
          </AccordionTab>
          <AccordionTab>
            <template #header>
              <span>Header II</span>
              <div class="p-1 bg-gray-300 rounded-md cursor-pointer ml-2" title="刪除" @click="doDelete(2)">
                <img src="../../assets/clear.svg" />
              </div>
            </template>
            Content 2
          </AccordionTab>
          <AccordionTab>
            <template #header>
              <span>Header III</span>
              <div class="p-1 bg-gray-300 rounded-md cursor-pointer ml-2" title="刪除" @click="doDelete(3)">
                <img src="../../assets/clear.svg" />
              </div>
            </template>
            Content 3
          </AccordionTab>
        </Accordion> -->
      </div>
    </div>
    <div class="hidden lg:block w-1/4 rounded-xl space-y-2 px-4 event-tips-sidebar"></div>
  </div>
  <div v-if="view_youtube">
    <Vue3DraggableResizable
      :initW="360"
      :initH="250"
      v-model:x="x"
      v-model:y="y"
      v-model:w="w"
      v-model:h="h"
      v-model:active="active"
      :draggable="true"
      :resizable="false"
      @activated="print('activated')"
      @deactivated="print('deactivated')"
      @drag-start="print('drag-start')"
      @resize-start="print('resize-start')"
      @dragging="doDragging()"
      @resizing="print('resizing')"
      @drag-end="print('drag-end')"
      @resize-end="print('resize-end')"
      class="rounded-xl cursor-move"
      style="background-color: #fff; border:1px #000 solid; z-index:2000;"
    >
      <i class="pi pi-times-circle text-gray-500 cursor-pointer" style="position: absolute; right:5px; top: 5px;" @click="view_youtube = !view_youtube"></i>
      <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
        <YouTube
          :src="src"
          width="320"
          height="200"
          @ready="onReady"
          @state-change="onStateChange"
          ref="youtube"
          :vars="vars"
        />
      </div>
    </Vue3DraggableResizable>
  </div>
</template>
<script>
  import Accordion from 'primevue/accordion';
  import AccordionTab from 'primevue/accordiontab';
  import DataTable from 'primevue/datatable';
  import Column from 'primevue/column';
  import Calendar from 'primevue/calendar';
  import InputSwitch from 'primevue/inputswitch';
  import Swal from 'sweetalert2/dist/sweetalert2.js'
  import 'sweetalert2/dist/sweetalert2.min.css'
  import Loading from 'vue3-loading-overlay';
  import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
  import "vue3-circle-progress/dist/circle-progress.css";
  import Vue3DraggableResizable from 'vue3-draggable-resizable'
  import 'vue3-draggable-resizable/dist/Vue3DraggableResizable.css'
  import axios from 'axios'
  import Qs from 'qs'

  export default {
    name: 'MarketingDate',
    props: {
      showMarketingDate: {
        type: Boolean
      },
      editPage: {
        type: Boolean
      },
      viewDatalist: {
        type: Object
      },
      lang: {
        type: Object
      },
      youtubeClose: {
        type: Boolean
      }
    },
    components: {
      Accordion,
      AccordionTab,
      DataTable,
      Column,
      Calendar,
      InputSwitch,
      Loading
    },
    data() {
      return {
        // start: '08/11/2021',
        // end: '08/31/2021',
        audienceName: null,
        activeIndex: null,
        starttime: null,
        endtime: null,
        useEndDate: false,
        isdisabled:false,
        startMinDate: null,
        endMinDate: null,
        x: 0,
        y: 0,
        h: 200,
        w: 320,
        active: false,
        src: "https://www.youtube.com/watch?v=VMMjP-UF6BY",
        vars: {
          rel: 0,
          start: 0,
          end: 0,
        },
        view_youtube: false,
        items: [
          {
            id:11,
            title: 'Title 1',
            editStatus: false,
            dataTableList:[
              {
                id:2,
                name:"受眾2",
                user:"<img src='https://private.autoturn.net/img/gear_duo.gif' width='30' title='分析中'>",
                dateTime:"資料產生中",
                itemEdit: false
              },

              {
                id:33,
                name:"受眾4",
                user:"123",
                dateTime:"2022/11/09",
                itemEdit: false
              }
            ],
          },
          {
            id:22,
            title: 'Title 2',
            editStatus: false,
            dataTableList:[
              {
                id:4,
                name:"受眾21",
                user:"123222",
                dateTime:"2022/11/10",
                itemEdit: true
              },
              {
                id:5,
                name:"受眾22",
                user:"456222",
                dateTime:"2022/11/11",
                itemEdit: true
              },
              {
                id:6,
                name:"受眾23",
                user:"7892222",
                dateTime:"2022/11/12",
                itemEdit: true
              }
            ],
          },
          {
            id:33,
            title: 'Title 3',
            editStatus: false,
            dataTableList:[
              {
                id:7,
                name:"受眾31",
                user:"1233333",
                dateTime:"2022/11/13",
                itemEdit: true
              },
              {
                id:8,
                name:"受眾32",
                user:"45633333",
                dateTime:"2022/11/14",
                itemEdit: true
              },
              {
                id:9,
                name:"受眾3333",
                user:"7893333",
                dateTime:"2022/11/15",
                itemEdit: true
              }
            ],
          },
        ],
        activeIndexNow: null,
        selectedCustomers:[]
      }
    },
    created() {
      let setTime = new Date();
      let toDay = setTime.setDate(setTime.getDate() + 1);
      setTime = new Date(toDay);
      let nowDay = setTime.getDate();
      let nowMonth = setTime.getMonth();
      let nowYear = setTime.getFullYear();
      // this.startMinDate = new Date();
      // this.startMinDate.setMonth(nowMonth);
      // this.startMinDate.setFullYear(nowYear);
      // this.startMinDate.setDate(nowDay);

      this.startMinDate = setTime

    //  console.log('this.startMinDate');
    //  console.log(this.startMinDate);
    //  console.log('setTime');
    //  console.log(setTime);
    //  console.log('nowDay');
    //  console.log(nowDay);
    //  console.log('nowMonth');
    //  console.log(nowMonth);
    //  console.log('nowYear');
    //  console.log(nowYear);
    },
    watch:{
      'youtubeClose':function(v){
      //  console.log('marketingmethod youtubeClose');
      //  console.log(v);

        let _tmpYoutubeType = v.split('_');

      //  console.log('_tmpYoutubeType');
      //  console.log(_tmpYoutubeType);

      //  console.log(typeof this.view_youtube);
      //  console.log(this.view_youtube);

        if(_tmpYoutubeType[0] != null && _tmpYoutubeType[0] != '' && typeof _tmpYoutubeType[0] != 'undefined'){
          if(_tmpYoutubeType[0] == 'false' || _tmpYoutubeType[1] != 'date'){
            this.view_youtube = false
          }
        }

      //  console.log(typeof this.view_youtube);
      //  console.log(this.view_youtube);
      },
      'viewDatalistData.start_date': function(v){
      //  console.log('viewDatalistData.start_date:'+v);
        if(v != '' && v != null){
          let setTime = new Date(v);
          let toDay = setTime.setDate(setTime.getDate() + 13);
          setTime = new Date(toDay);
          let lastDay = setTime.getDate();
          let lastMonth = setTime.getMonth();
          let lastYear = setTime.getFullYear();
          // this.endMinDate = new Date();
          // this.endMinDate.setMonth(lastMonth);
          // this.endMinDate.setFullYear(lastYear);
          // this.endMinDate.setDate(lastDay);

        //  console.log('this.endMinDate');
        //  console.log(this.endMinDate);

          this.endMinDate = setTime

          let startTime = v;
          let endTime = this.viewDatalistData.end_date;
          let diffType = 'day';

          // console.log('startTime:'+startTime);
          // console.log('endTime:'+endTime);

          // startTime = startTime.replace(/\-/g, "/");
          // endTime = endTime.replace(/\-/g, "/");
          //將計算間隔類性字符轉換為小寫
          let gapTime = 0;

          if(endTime != '' && endTime != null){
            diffType = diffType.toLowerCase();
            var sTime =new Date(startTime); //開始時間
            var eTime =new Date(endTime); //結束時間
            //作為除數的數字
            var timeType =1;
            switch (diffType) {
                case"second":
                    timeType =1000;
                break;
                case"minute":
                    timeType =1000*60;
                break;
                case"hour":
                    timeType =1000*3600;
                break;
                case"day":
                    timeType =1000*3600*24;
                break;
                default:
                break;
            }
            gapTime = parseInt((eTime.getTime() - sTime.getTime()) / parseInt(timeType));
          }

          // console.log('start_date 天數差：'+gapTime);

          this.$emit('childGapTime', gapTime);
        }
      },
      'viewDatalistData.end_date': function(v){
      //  console.log('viewDatalistData.end_date:'+v);
        this.$emit('childEndTime', v);

        if(v != '' && v != null){
          // this.GetDateDiff(this.startMinDate, v, 'day');

          let startTime = this.viewDatalistData.start_date;
          let endTime = v;
          let diffType = 'day';

          // console.log('startTime:'+startTime);
          // console.log('endTime:'+endTime);

          // startTime = startTime.replace(/\-/g, "/");
          // endTime = endTime.replace(/\-/g, "/");
          //將計算間隔類性字符轉換為小寫
          let gapTime = 0;

          if(startTime != '' && startTime != null){
            diffType = diffType.toLowerCase();
            var sTime =new Date(startTime); //開始時間
            var eTime =new Date(endTime); //結束時間
            //作為除數的數字
            var timeType =1;
            switch (diffType) {
                case"second":
                    timeType =1000;
                break;
                case"minute":
                    timeType =1000*60;
                break;
                case"hour":
                    timeType =1000*3600;
                break;
                case"day":
                    timeType =1000*3600*24;
                break;
                default:
                break;
            }
            gapTime = parseInt((eTime.getTime() - sTime.getTime()) / parseInt(timeType));
          }

          // console.log('end_date 天數差：'+gapTime);

          this.$emit('childGapTime', gapTime);
          // let setTime = new Date(v);
          // let toDay = setTime.setDate(setTime.getDate() + 14);
          // setTime = new Date(toDay);
          // let lastDay = setTime.getDate();
          // let lastMonth = setTime.getMonth();
          // let lastYear = setTime.getFullYear();
          // this.endMinDate = new Date();
          // this.endMinDate.setMonth(lastMonth);
          // this.endMinDate.setFullYear(lastYear);
          // this.endMinDate.setDate(lastDay);
        }
      },
      'viewDatalistData.use_end_date': function(value){
        // console.log('viewDatalistData.use_end_date:'+value);
        this.$emit('childUseEndDate', value);

        if(value == true){
          this.viewDatalistData.end_date = '0000-00-00';
        }
      },
      // 'selectedCustomers':function(v){
      // //  console.log('selectedCustomers');
      // //  console.log(v);
      // }
      // 'useEndDate': function(value){
      // //  console.log('useEndDate:'+value);
      // }
      'activeIndex':function(v){
      //  console.log('activeIndex');
      //  console.log(v);
      //  console.log('b activeIndexNow');
      //  console.log(this.activeIndexNow);

        if(this.activeIndexNow != v){
          this.selectedCustomers = [];
        }

      //  console.log('selectedCustomers');
      //  console.log(this.selectedCustomers);

        this.activeIndexNow = v

      //  console.log('a activeIndexNow');
      //  console.log(this.activeIndexNow);
      },
    },
    methods: {
      onReady() {
      //  console.log('youtube');
        this.$refs.youtube.playVideo()
        // this.$refs.youtube.pauseVideo()
      },
      onStateChange(e){
      //  console.log(e);

        if(e.data == 0){
          this.view_youtube = false
        }
      },
      teachVideo(){
        this.$emit('checkClose')
        // let elem = document.getElementById('marketingDate');
        // let positio = this.getPosition(elem);
        // console.log('x:'+positio.x);
        // console.log('y:'+positio.y);

        // this.x = positio.x + parseInt(80);
        // this.y = positio.y

        var windowWidth = window.innerWidth;
        var windowHeight = window.innerHeight;

        // console.log('windowWidth');
        // console.log(windowWidth);
        // console.log('windowHeight');
        // console.log(windowHeight);

        this.x = windowWidth - parseInt(390);
        this.y = windowHeight - parseInt(350);

        this.view_youtube = true;
        this.$emit('childYoutube', 'true_date')

        this.src = "https://www.youtube.com/watch?v=VMMjP-UF6BY"
        this.vars.start = 240
        this.vars.end = 283
      },
      getPosition(element) {
        let x = 0;
        let y = 0;

        while ( element ) {
          x += element.offsetLeft - element.scrollLeft + element.clientLeft;
          y += element.offsetTop - element.scrollLeft + element.clientTop;
          element = element.offsetParent;
        }

        return { x: x, y: y };
      },
      print(val) {
      //  console.log(val)
      },
      doDragging(){
      //  console.log('doDragging');
      },
      addItem(){
        var todayForm = new Date();
        var yearForm = todayForm.getFullYear();
        var dateForm = String(todayForm.getDate()).padStart(2, '0');
        var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        todayForm = yearForm + monthForm + dateForm + timeForm;

        let audienceName = '受眾包_'+todayForm;
        let audienceId = Math.floor(Math.random()*2000)+1;

        // if(audienceName != '' && audienceName != null && typeof audienceName != 'undefined'){
          this.items.push({
            id:audienceId,
            title: audienceName,
            editStatus: false,
            dataTableList:[]
          });

          // this.audienceName = null;
        // } else {
        //   Swal.fire(
        //             '機密受眾-新增受眾',
        //             '請填寫受眾名稱。',
        //             'error'
        //           )
        // }
      },
      doDelete(v){
      //  console.log('doDelete');
      //  console.log(v);

        if((v != '' && v != null && typeof v != 'undefined') || v == 0){
          Swal.fire({
            title: '機密受眾-刪除受眾',
            html: '您要刪除此受眾包嗎？',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: '是',
            cancelButtonText: '取消',
          }).then((result) => {
            if (result.isConfirmed) {
            //  console.log(this.items[v]);
              this.items.splice(v, 1);
            //  console.log(this.items);
            }
          })
        }
      },
      doAdd(v){
      //  console.log('doAdd');
      //  console.log(v);

        let url = "https://www.autoturn.net/api/campaign_confidential_audience.php";
        // let url = `//api.github.com/users/${login}`;

        Swal.fire({
          title: '新增來源資料',
          text: '請輸入來源資料的超連結。',
          input: 'text',
          inputAttributes: {
            autocapitalize: 'off'
          },
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: '新增',
          cancelButtonText: '取消',
          preConfirm: (linkData) => {
          //  console.log('linkData');
          //  console.log(linkData);
            if(linkData != '' && linkData != null && typeof linkData != 'undefined'){
              return axios
                .post(url, Qs.stringify({
                  s_code: this.$route.params.id,
                  link: linkData
                }))
                .then((response) => {
                //  console.log('response.data');
                //  console.log(response.data);
                  if (response.data.status != 'success') {
                    throw new Error(response.data.info)
                  }
                  return response
                })
                .catch(error => {
                //  console.log('error');
                //  console.log(error);
                  Swal.showValidationMessage(
                    `Request failed: ${error}`
                  )
                })
            } else {
              // Swal.fire(
              //             '機密受眾-新增來源資料',
              //             '請填寫來源資料的超連結。',
              //             'error'
              //           )
              Swal.showValidationMessage(
                `請填寫來源資料的超連結。`
              )
            }
          },
          allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
        //  console.log('result');
        //  console.log(result);
          if (result.isConfirmed) {
            // Swal.fire({
            //   title: `${result.value.login}'s avatar`,
            //   imageUrl: result.value.avatar_url
            // })
            this.items[v].dataTableList.push(result.value.data.return_data);
          }
        })
      },
      change(e){
      //  console.log('change');
      //  console.log(e);
        // this.items[v].selectedCustomers = [];
        // console.log(this.items[v].selectedCustomers);
      },
      refreshItem(v){
      //  console.log('refreshItem');
      //  console.log(this.selectedCustomers);
      },
      deleteItem(v){
      //  console.log('deleteItem');
      //  console.log(this.selectedCustomers);
        let selectedCustomersLength = this.selectedCustomers.length;
        let listData = [];
        let deleteData = [];
        let deleteTitleData = [];
        let itemsDataTableListLength = this.items[v].dataTableList.length;

      //  console.log('selectedCustomersLength');
      //  console.log(selectedCustomersLength);

        for(let i = 0; i < selectedCustomersLength; i++){
        //  console.log('this.selectedCustomers['+i+']');
        //  console.log(this.selectedCustomers[i]);
          deleteData.push(this.selectedCustomers[i].id);
          deleteTitleData.push(this.selectedCustomers[i].name);
        }

        for(let j = 0; j < itemsDataTableListLength; j++){
          listData.push(this.items[v].dataTableList[j].id);
        }

      //  console.log('itemsDataTableListLength');
      //  console.log(itemsDataTableListLength);

      //  console.log('deleteData');
      //  console.log(deleteData);

      //  console.log('listData');
      //  console.log(listData);

      //  console.log('this.selectedCustomers');
      //  console.log(this.selectedCustomers);

        let audienceName = this.items[v].title;
        let swalDeleteTitle = deleteTitleData.join('、');
        if(selectedCustomersLength == itemsDataTableListLength){
        //  console.log('全刪');
          // let audienceName = this.items[v].title;
          Swal.fire({
            title: '機密受眾-刪除來源資料',
            html: '您確定要刪除「<span style="color:red;">'+swalDeleteTitle+'</span>」的來源資料嗎？',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: '是',
            cancelButtonText: '取消',
          }).then((result) => {
            if (result.isConfirmed) {
              // console.log(this.items[v]);
              // this.items.splice(v, 1);
              // console.log(this.items);
              // this.activeIndex = null;
              this.items[v].dataTableList = [];
              this.selectedCustomers = [];
            }
          })

          // this.activeIndex = null;
        } else {
        //  console.log('部分刪');
          // for(let j = 0; j < itemsDataTableListLength; j++){
          // //  console.log('this.items['+v+'].dataTableList['+j+']');
          // //  console.log(this.items[v].dataTableList[j]);
          //   let item = this.items[v].dataTableList[j];
          //   if(item != '' && item != null && typeof item != 'undefined'){
          //   //  console.log('indexOf');
          //   //  console.log(deleteData.indexOf(this.items[v].dataTableList[j].id));
          //   //  console.log(this.items[v].dataTableList[j].id);
          //     if(deleteData.indexOf(this.items[v].dataTableList[j].id) >= 0){
          //     //  console.log('刪除this.items['+v+'].dataTableList['+j+']');
          //       this.items[v].dataTableList.splice(j, 1);
          //     }
          //   }
          // }

          Swal.fire({
            title: '機密受眾-刪除來源資料',
            html: '您確定要刪除「<span style="color:red;">'+swalDeleteTitle+'</span>」的來源資料嗎？',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: '是',
            cancelButtonText: '取消',
          }).then((result) => {
            if (result.isConfirmed) {
              let resultData = listData.filter((e)=>{
                return deleteData.indexOf(e) === -1
              });

            //  console.log('resultData');
            //  console.log(resultData);

              if(resultData.length > 0){
                let _tmp_items = [];
                for(let k = 0; k < itemsDataTableListLength; k++){
                //  console.log('this.items['+v+'].dataTableList['+k+']');
                //  console.log(this.items[v].dataTableList[k]);
                  if(resultData.indexOf(this.items[v].dataTableList[k].id) >= 0){
                    _tmp_items.push(this.items[v].dataTableList[k]);
                  }
                }

                this.items[v].dataTableList = _tmp_items;
                this.selectedCustomers = [];
              }
            }
          })
        }

      //  console.log('this.items['+v+'].dataTableList');
      //  console.log(this.items[v].dataTableList);
      },
      edit(v){
      //  console.log('edit');
      //  console.log(v);

        this.items[v].editStatus = true;

        // let url = "https://www.autoturn.net/api/campaign_confidential_audience_name_update.php";
        // let name = this.items[v].title;

        // Swal.fire({
        //   title: '修改受眾包名稱 - '+name,
        //   text: '改名為：',
        //   input: 'text',
        //   inputAttributes: {
        //     autocapitalize: 'off'
        //   },
        //   showCancelButton: true,
        //   confirmButtonColor: '#3085d6',
        //   cancelButtonColor: '#d33',
        //   confirmButtonText: '確定',
        //   cancelButtonText: '取消',
        //   preConfirm: (nameData) => {
        //   //  console.log('nameData');
        //   //  console.log(nameData);
        //     return axios
        //       .post(url, Qs.stringify({
        //         s_code: this.$route.params.id,
        //         audience_name: nameData
        //       }))
        //       .then((response) => {
        //       //  console.log('response.data');
        //       //  console.log(response.data);
        //         if (response.data.status != 'success') {
        //           throw new Error(response.data.info)
        //         }
        //         return response
        //       })
        //       .catch(error => {
        //       //  console.log('error');
        //       //  console.log(error);
        //         Swal.showValidationMessage(
        //           `Request failed: ${error}`
        //         )
        //       })
        //   },
        //   allowOutsideClick: () => !Swal.isLoading()
        // }).then((result) => {
        // //  console.log('result');
        // //  console.log(result);
        //   if (result.isConfirmed) {
        //     // Swal.fire({
        //     //   title: `${result.value.login}'s avatar`,
        //     //   imageUrl: result.value.avatar_url
        //     // })
        //     this.items[v].title = result.value.data.title;
        //   }
        // })
      },
      update(v){
        this.items[v].editStatus = false;
      },
      submitData(v) {
      //  console.log('submitData');
      //  console.log(v);

        // this.$refs['myinput'][v].focus()
        this.$refs[`myinput${v}`].focus()
      }
      // GetDateDiff(startTime, endTime, diffType) {
      //     //將xxxx-xx-xx的時間格式，轉換為 xxxx/xx/xx的格式
      //     startTime = startTime.replace(/\-/g, "/");
      //     endTime = endTime.replace(/\-/g, "/");
      //     //將計算間隔類性字符轉換為小寫
      //     diffType = diffType.toLowerCase();
      //     var sTime =new Date(startTime); //開始時間
      //     var eTime =new Date(endTime); //結束時間
      //     //作為除數的數字
      //     var timeType =1;
      //     switch (diffType) {
      //         case"second":
      //             timeType =1000;
      //         break;
      //         case"minute":
      //             timeType =1000*60;
      //         break;
      //         case"hour":
      //             timeType =1000*3600;
      //         break;
      //         case"day":
      //             timeType =1000*3600*24;
      //         break;
      //         default:
      //         break;
      //     }
      //     return parseInt((eTime.getTime() - sTime.getTime()) / parseInt(timeType));
      // }
    },
    computed: {
      editPageType: {
        get: function () {
          return this.editPage
        },
        set: function (value) {
          this.$emit('update:editPageType', value)
        },
      },
      viewDatalistData: {
        get: function () {
          return this.viewDatalist
        },
        set: function (value) {
          this.$emit('update:viewDatalistData', value)
        },
      }
    }
  }
</script>

<style lang="scss" scoped>
  ::v-deep(.calendar-group) {
    .p-calendar .p-inputtext {
      padding: 0.25rem;
      border: 0px;
    }
  }
</style>